import { Box, Button, Stack, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { AssignDiscipline, AssignStatus } from '../../models/Review'
import { assignEngineerToProject } from '../../services/reviewService'

interface AssignEngineerRequestedProps {
  discipline: AssignDiscipline
}

const AssignEngineerRequestedComponent: React.FC<
  AssignEngineerRequestedProps
> = ({ discipline }) => {
  const dispatch = useDispatch<any>()

  const onRevokeClick = () => {
    dispatch(
      assignEngineerToProject({
        discipline: discipline.discipline,
        discipline_status: AssignStatus.NotAssigned,
        status: AssignStatus.NotAssigned,
        organization_id: 9,
        user_id: null,
        file_id: discipline.file_id,
      }),
    )
  }

  return (
    <Stack
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1rem'}
      width={'100%'}
      minHeight={'5.8rem'}
    >
      <Typography
        sx={{
          color: '#797979',
          fontSize: '0.7rem',
          fontWeight: 500,
          lineHeight: 'тormal',
          width: '60%',
          textAlign: 'center',
        }}
      >
        You request has been sent to the Engineering team to be assigned
      </Typography>
      <Box display={'flex'} gap={'1rem'}>
        <Button
          variant='outlined'
          size='small'
          sx={{
            fontSize: '0.64rem',
            border: '1px solid #FF3B47',
            textTransform: 'capitalize',
            height: '1.5rem',
            color: '#FF3B47',
          }}
        >
          Contact Admin
        </Button>
        <Button
          variant='contained'
          size='small'
          onClick={() => onRevokeClick()}
          sx={{
            fontSize: '0.64rem',
            background: '#FF3B47',
            textTransform: 'capitalize',
            height: '1.5rem',
            color: '#fff',
          }}
        >
          Revoke Request
        </Button>
      </Box>
    </Stack>
  )
}

export default AssignEngineerRequestedComponent
